import useSWRInfinite from 'swr/infinite';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const useInfiniteDiscoverySearchV2 = (discoveryService, params, configs) => {
  var _b, _c;
  const _a = configs || {}, {
    transform = (data2) => data2
  } = _a, swrConfigs = __objRest(_a, [
    "transform"
  ]);
  const { data, size, setSize, isValidating, error } = useSWRInfinite((page) => [
    __spreadProps(__spreadValues({}, params), { page: page + 1 }),
    "discovery-search-v2"
  ], async (payload) => {
    const response = await discoveryService.search(payload);
    return transform == null ? void 0 : transform(response);
  }, __spreadValues({}, swrConfigs));
  const isEmpty = data && ((_b = data[0].products) == null ? void 0 : _b.length) === 0;
  const hasMore = (((_c = data == null ? void 0 : data[0]) == null ? void 0 : _c.total) || 0) > size * ((params == null ? void 0 : params.pageSize) || 10);
  const loadmore = () => {
    setSize((page) => page + 1);
  };
  return {
    loading: isValidating,
    hasMore,
    data,
    loadmore,
    size,
    isEmpty: !!isEmpty,
    error
  };
};

export { useInfiniteDiscoverySearchV2 };
